import axios from 'axios';
import store from '../redux/store/store';
const API_BULK_URL = import.meta.env.VITE_API_URL;

const BulkPriceTransactionService = {
  addBulkPrice: async (request, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_BULK_URL}/BulkPriceTransaction`,
        request,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response?.data;
    } catch (error) {

      console.error("bulk eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  fetchBulkPrice: async (userId, token,page,pageSize) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/BulkPriceTransaction', {
        params: {
          withCategory:true,  
          withMarketpleaces:true,  
          userId: userId,
          page:page,
          pageSize:pageSize
        },
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      });
      return response?.data;
    } catch (error) {
      console.error('Error fetching bulk:', error);
      throw error;
    }
  },

 
}
export default BulkPriceTransactionService;
